// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57bb7303","453":"4ea4fa36","732":"9a458f03","977":"20c823e9"}[chunkId] + ".chunk.js";
};